import { GraphQLClient } from 'graphql-request';
import { useConfig } from 'providers';
import { useMemo } from 'react';
import { GetBoatsListByIDs, GetBoatsListByIDsVariables, useGetBoatsListByIDs } from '../../graphql/cms';

export function useBoatsListByIDs(ids: string[], placeholderData?: GetBoatsListByIDs) {
  const { cmsGraphQlUrl } = useConfig();

  if (!cmsGraphQlUrl || !cmsGraphQlUrl.length) {
    throw new Error('No cmsGraphQlUrl provided in config.');
  }
  const graphQLClient = new GraphQLClient(cmsGraphQlUrl || '');

  const variables = useMemo<GetBoatsListByIDsVariables>(
    () => ({
      idFilters: ids.map((id) => ({ documentId: { eq: id } })),
    }),
    [ids],
  );

  const enabled = useMemo<boolean>(() => !!ids.length, [ids]);

  const queryInfo = useGetBoatsListByIDs(graphQLClient, variables, {
    gcTime: Infinity,
    staleTime: Infinity,
    enabled,
    placeholderData,
    refetchOnMount: false,
  });

  return queryInfo;
}
